/**
 * Contains code used to startup the full application.  Not used in unit tests
 */

// load setup FIRST (config needs polyfills setup here)
import setup from './setup'

import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import AppRouter from './app-router'
import TestRouter from '../ui-tests/components/test-router'
import * as MainView from './main'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import moment from 'moment'
import conductor from 'scoreboard/components/conductor'
import HttpStatus from 'http-status-codes'
import deviceType from 'scoreboard/components/device-type'
import favicon from 'scoreboard/components/favicon'
import config from 'scoreboard/components/config'
import FontFaceObserver from 'fontfaceobserver'
import sessionTimer from './components/session-timer'
import PasswordReset from './components/password-reset'
import layoutManager from 'scoreboard/components/layout-manager'
import appDisplay from 'scoreboard/components/app-display'
import MasterSubscriptionAgreementDialog from 'scoreboard/admin/master-subscription-agreement-dialog'
import license from 'scoreboard/components/license'
import ErrorView from 'scoreboard/components/error-view'
import Xhr, {setToken} from 'scoreboard/components/xhr'
import { initialize } from 'scoreboard/components/scoreboard-url'
import Url from 'scoreboard/components/url'
const { getQueryParams } = Url
import { XHR_HEADERS_AVAILABLE } from 'scoreboard/components/permissions'
import { isV5 } from 'scoreboard/components/version'

setup()

// #11409 Proactively load web fonts, and delay rendering until they are loaded; this ensures the accuracy
// of any code that relies on measuring the size of rendered text, like performance bubbles and speedometers
// Font definitions come from sass/components/fonts.scss
let fonts = [
    { family: 'Inter Var', weight: '100 900' } // Use the full range of the variable font
  ]

if (isV5()) {
  fonts = [
    { family: 'Source Sans Pro', weight: 400 },
    { family: 'Source Sans Pro', weight: 600 },
    { family: 'Source Sans Pro', weight: 700 },
    { family: 'Noto Sans JP', weight: 400 }
  ]
}

fonts.push({ family: 'Saudi Riyal' })

const fontObservers = fonts.map(font =>
	new FontFaceObserver(font.family, { weight: font.weight, style: 'normal' })
)
const fontPromises = Promise.all(fontObservers.map(font => font.load()))

$(function () {

	window.afterEntry = function () {
		// Note: none of these messages are localized because i18n isn't available yet.
		// They are only displayed in the dev tools console, though, so a typical
		// user won't see them

		var startFontWaiting = moment()
		fontPromises.then(function () {
			console.log('Delayed rendering for ' + moment().diff(startFontWaiting) + 'ms while waiting for web fonts to load')
			next()
		}, function (font) {
			let message = 'Timeout loading web font.'

			message += ' Loading application using fallback fonts instead.'

			if (font) {
				message += ` Failed font: "${font.family} ${font.style} ${font.weight}"`
			}

			console.warn(message)
			next()
		})
	}

	/**
	 * Displays error message and icon for failed login or failed password reset request
 	 */
	window.displayError = function(message) {
		$('.form').addClass('has-error')
		$('.login-message').empty().text(message)
			.removeClass('is-not-displayed')
		// #32679 hide the logout message if it was showing before the error
		$('.logout-message').addClass('is-not-displayed')
		$('.button-primary').removeClass('is-loading').attr('disabled', false)
	}

	/**
	 * A successful login will return the globals data, but the user may need
	 * to reset their password before gaining access to the application.
	 *
	 */
	function next() {
		var contextPath = window.contextPath
		var xhr = new Xhr({xhr: window.loginRequest})
		// the data used to build the "globals" object
		var data = xhr.responseJSON

		if (data.redirect) {
			// Supports a client side redirect for OpenId Login's
			// which can't be done using a server side redirect (CORS violation)
			location.href = data.redirect
		} else if (xhr.status === HttpStatus.OK) {
			// Once we know a login happened with a valid csrf token read it into Xhr
			setToken()
			initialize({
				baseUrl: window.location.origin + contextPath + '/',
				embeddedToken: window.embeddedToken
			})
			Backbone.trigger('load', data)
			var loginForm = $('form.login')
			if (!_.isEmpty(loginForm) &&
				_.get(data, 'user.forcePasswordChange') &&
				// #20510 the public read only user can't change their password
				_.get(data, 'user.id') != _.get(data, 'config.publicReadOnlyUserId')) {
				// This will catch all authenticated users that have their forcePasswordChange flag set
				loadPasswordReset(loginForm)
			} else {
				start(data)
			}
		} else if (!Xhr.requiresLogin(xhr)) {
			window.displayError(data.message)
		}
	}

	function loadPasswordReset(loginForm) {
		loginForm.get(0).onsubmit = undefined
		// #15620 display appropriate message if this is a reset request via email
		let emailReset = _.endsWith(window.location.pathname, 'password-reset')
		var passwordReset = new PasswordReset({el: loginForm, emailReset: emailReset})
		passwordReset.on('done', function(data) {
			start(data)
		})
		passwordReset.render()
	}

	function start (data) {
		var startTime = moment()
		globals.loggedIn = true

		!layoutManager.sharedResource && sessionTimer.start()

		// setup permissions (see permissions.js)
		var request = window.loginRequest
		Backbone.trigger(XHR_HEADERS_AVAILABLE, request)

		// initialize Backbone.history before rendering anything
		conductor.router = new AppRouter
		Backbone.history.start({
			pushState: true,
			root: window.contextPath,
			// #6590 needed when loading an invalid URL or else the nav pane
			// renders before MainView creates the structure of the application
			// and then ends up appearing blank
			silent: true
		})

		MainView.start()

		// Remember the state of the chosen database
		var previousDatabaseId = globals.readLocal('databaseId')
		globals.storeLocal('databaseId', globals.databaseId)

		// #19984 #11776 if the user was automatically logged out and then they
		// change databases, don't go back to their old URL, because it was in
		// a different database and likely doesn't point at the right data
		var databaseChanged = previousDatabaseId && (previousDatabaseId !== globals.databaseId)
		if (databaseChanged && globals.readLocal('timedOut')) {
			delete window.requestedUri
		}
		globals.removeLocal('timedOut')

		// go to the right page AFTER we know we are logged in and the UI is in place
		var url
		if (window.requestedUri) {
			const decodedUrl = window.requestedUri
			// remove querystring params that are not needed beyond initial load
			const allParams = getQueryParams(decodedUrl)
			const params = $.param(_.omit(allParams, 'periodId', 'database'))
			const queryString = _.size(params) === 0 ? '' : `?${params}`
			url = decodedUrl.split('?')[0] + queryString
		} else {
			url = 'home/welcome'
		}
		delete window.requestedUri

		if (!globals.isOperationalMode()) {
			var allowedUrls = ['admin/server', 'admin/databases',
				'admin/licenses', 'admin/profile']
			if (_.indexOf(allowedUrls, url) == -1) {
				url = 'admin/diagnostics'
			}
		}

		if (config.msaRequired && !license.trial) {
			appDisplay.once('render:display', () => {
				const description = i18n.get('admin.msa.description', i18n.get('app.name'))
				const dialog = new MasterSubscriptionAgreementDialog({description})
				appDisplay.dialog(dialog)
			})
		}

		// must be before the conductor.navigate call
		new TestRouter()

		conductor.navigate(url, { trigger: true, replace: true })

		// If the user should see an error message upon navigation to a url
		// (e.g. deleted files redirect to underlying resource; #23354)
		const message = window.errorMessage
		if (message) {
			appDisplay.once('render:display', () => {
				// A view could re-route itself
				// (Briefings will navigate to the first slide)
				// So only open the dialog after the view is rendered so that it
				// does not get dismissed prematurely
				appDisplay.dialog(new ErrorView({message}))
			})
		}

		if (deviceType.trident || deviceType.edge) {
			favicon('favicon.ico?' + new Date().getTime())
		}

		// to ease development
		window.jQuery = $
		window.lodash = _

		// cleanup window
		if (window.cleanupGlobalLogin) {
			window.cleanupGlobalLogin()
			delete window.cleanupGlobalLogin
		}

		console.log('Initial app load and page rendering took ' + moment().diff(startTime) + 'ms')

		// Remove the loading animation once the app has started.
		$('svg.skeleton').remove()
	}

})
